import { Injectable } from '@angular/core';
import { OrderApiService } from './order.api.service';
import {BehaviorSubject, Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Restaurant} from '../models/restaurant.model';
import { RestaurantService } from './restaurant.service';
import { RestaurantStore } from '../stores/restaurant.store';
import { SERVICE_ITEM_MERCHANTS, SERVICE_ITEM_LOCATIONS } from '../constants';
import { RouteService } from './route.service';
import { CartStore } from '../stores/cart.store';
import {EstimateOrder} from '../models/order.model';
import { dataToEstimateOrders} from '../dto/restaurant.dto';
import { Item } from '../models/catalog.model';

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  public itemServiceProduct: Item = new Item();

  constructor(
    private apiService: OrderApiService,
    private restaurantService: RestaurantService,
    private restaurantStore: RestaurantStore,
    private routeService: RouteService,
    private cartStore: CartStore
  ) { }

  public checkMerchantId(): boolean {
    return SERVICE_ITEM_MERCHANTS.includes(this.routeService.getMerchantId());
  }
  public checkLocationId(locationId: string): boolean {
    return SERVICE_ITEM_LOCATIONS.includes(locationId);
  }
  public checkServiceItem(): boolean {
    return this.cartStore.cartItems.some(item => item.isService);
  }

  public estimateThrottling(locationId: string, estimateObject: EstimateOrder[]): Observable<EstimateOrder[]> {
    return this.apiService.post(`locations/${locationId}/orders/estimate`, estimateObject).pipe(
      map(response => dataToEstimateOrders(response))
    );
  }

  public getSuggestionItems(locationId: string, items: string[]): Observable<string[]> {
    return this.apiService.post(`locations/${locationId}/addons`, items);
  }

  public getMostOrderedItemsByCustomer(locationId: string, customerId: string, items: string[]): Observable<string[]> {
    return this.apiService.post(`locations/${locationId}/items/${customerId}`, items);
  }

  public isSoldOut(product: Item, restaurant: Restaurant): boolean {
    return (this.isProductSold(product, restaurant) && this.getQuantity(product) <= 0) || this.allSoldOut(product);
  }

  public isProductSold(product: Item, restaurant: Restaurant): boolean {
    const variationsAvailable = [];
    for (const variation of product.variations) {
      if (variation.track_inventory) {
        if (variation.quantity_remaining > 0) {
          variationsAvailable.push(variation);
        }
      } else {
        return false;
      }
    }
    return variationsAvailable.length === 0;
  }

  public getQuantity(product: Item): number {
    let quantity = 0;
    for (const variation of product.variations) {
      if (variation.quantity_remaining === null) {
        return Number.MAX_VALUE;
      } else if (variation.quantity_remaining > 0) {
        quantity += variation.quantity_remaining;
      }
    }
    return quantity;
  }

  public allSoldOut(product: Item): boolean {
    return product.variations.filter(variation => !variation.sold_out).length === 0;
  }
}
